import { createContext } from 'react';

import { ProfitabilityItem } from '@totem/components/ticketing/details/profitability/types';

interface Context {
  data: ProfitabilityItem;
  loading: boolean;
}

export default createContext<Context>({
  data: null,
  loading: false,
});
